export const COLORS = {
  darkModeBg: "#010219",
  white: "#FFFFFF",
  black: "#000000",
  grey: "#262636",
  lightGrey: "#D9D9D9",
  // green: "#1D8C23",
  green: "#298ea2",
  darkGrey: "#2D3748",
  lightBrown: "#DCDCDC",
  chartbg: "#242438",
  // lightGreen: "#E4F3E5",
  lightGreen: "#56a6b6",

  //AAHERA COLOrs(LIGHT MODE)
  primary: "#298ea2",
  primaryDark: "#164758",

  // primary: "#1D8C23",
  // primaryDark: "#1D8C23",
  primaryLight: "#56a6b6",
  secondary: "#FC7067",
  bgGrey: "#F7F7F7",
  bgColor: "#298ea2",
  bgColorLight: "#F9F9F9",
  lightPink: "#FEE8E7",
};
